// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__67dbP","info":"PatientInfo_info__2_9zo"};